import React from 'react';
import { Trash2 } from 'lucide-react';
import toast from 'react-hot-toast';
import { useSupabase } from '../../hooks/useSupabase';
import { abvigAPI } from '../../services/api';
import DataTable from '../../components/Tables/DataTable';
import { formatDate } from '../../utils/helpers';

export default function Subscribers() {
  const { data, refetch } = useSupabase(abvigAPI.getSubscribers);

  const handleDelete = async (id) => {
    if (window.confirm('Are you sure you want to delete this subscriber?')) {
      try {
        // Note: You'll need to implement deleteSubscriber in your API
        toast.success('Subscriber deleted successfully');
        refetch();
      } catch (error) {
        toast.error('Failed to delete subscriber');
      }
    }
  };

  const columns = [
    { key: 'email', label: 'Email', sortable: true },
    { 
      key: 'subscribed_at', 
      label: 'Subscribed',
      render: (value) => formatDate(value)
    },
  ];

  const actions = [
    {
      label: 'Delete',
      icon: <Trash2 className="w-4 h-4 text-red-600" />,
      onClick: (item) => handleDelete(item.id),
      className: 'hover:bg-red-50'
    },
  ];

  return (
    <div>
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-900">Subscribers</h1>
        <p className="text-gray-600">Manage newsletter subscribers</p>
      </div>

      <DataTable
        columns={columns}
        data={data || []}
        title={`Total: ${data?.length || 0} subscribers`}
        actions={actions}
        searchPlaceholder="Search subscribers..."
      />
    </div>
  );
}